module.exports = __webpack_public_path__ + "static/media/Gor 2018.10.12-3.b202b7f1.webp";